import styled from 'styled-components';

const Spacer = styled.div`
  margin-bottom: ${({ y }) => y || 0};
  margin-right: ${({ x }) => x || 0};
  display: ${({ x }) => (x ? 'inline-block' : 'block')};
`;

export default Spacer;
